<template>
  <!-- Avatar button + display settings dropdown in the navbar (App.vue, which also holds
       its styles: .ff-user, .ff-menu, ...). -->
  <div class="ff-user-wrap" ref="root">
    <button class="ff-user" :class="{ 'is-open': open }" :title="$t('common.menu.title')" @click="open = !open">
      <span class="ff-avatar">{{ String(user || '?').charAt(0).toUpperCase() }}</span>
      <span class="ff-user-name">{{ user }}</span>
      <svg class="ff-caret" viewBox="0 0 24 24"><path d="m6 9 6 6 6-6"/></svg>
    </button>
    <div v-if="open" class="ff-menu">
      <div class="ff-menu-sec">
        <div class="ff-menu-label">{{ $t('common.menu.language') }}</div>
        <div class="ff-seg">
          <button
            v-for="l in LANGUAGES"
            :key="l.key"
            :class="{ 'is-on': ui.lang === l.key }"
            @click="set('lang', l.key)"
          >{{ l.label }}</button>
        </div>
      </div>
      <div class="ff-menu-sec">
        <div class="ff-menu-label">{{ $t('common.menu.orderHist') }}</div>
        <div class="ff-seg">
          <button
            v-for="v in ORDER_HIST_VARIANTS"
            :key="v.key"
            :class="{ 'is-on': ui.orderHist === v.key }"
            :title="$t('common.menu.' + v.i18n + 'Title')"
            @click="set('orderHist', v.key)"
          >{{ $t('common.menu.' + v.i18n) }}</button>
        </div>
      </div>
      <div class="ff-menu-sec">
        <div class="ff-menu-label">{{ $t('common.menu.textSize') }}</div>
        <div class="ff-seg">
          <button
            v-for="f in FONT_SIZES"
            :key="f.key"
            :class="{ 'is-on': ui.font === f.key }"
            :title="$t('common.menu.' + f.i18n)"
            :style="{ fontSize: (12 * f.scale) + 'px' }"
            @click="set('font', f.key)"
          >A</button>
        </div>
      </div>
      <div class="ff-menu-sec">
        <div class="ff-menu-label">{{ $t('common.menu.colorTheme') }}</div>
        <div class="ff-swatches">
          <button
            v-for="t in THEMES"
            :key="t.key"
            class="ff-swatch"
            :class="{ 'is-on': ui.theme === t.key }"
            @click="set('theme', t.key)"
          >
            <span class="ff-swatch-dot" :style="{ background: t.swatch }"></span>{{ t.label }}
          </button>
          <label class="ff-swatch ff-swatch-custom" :class="{ 'is-on': ui.theme === 'custom' }" :title="$t('common.menu.customTitle')">
            <span class="ff-swatch-dot ff-swatch-picker" :style="{ background: ui.custom }">
              <input type="color" :value="ui.custom" @input="setCustom($event.target.value)" @click="set('theme', 'custom')">
            </span>{{ $t('common.menu.custom') }}
          </label>
        </div>
      </div>
      <div class="ff-menu-sec">
        <div class="ff-menu-label">{{ $t('common.menu.background') }}</div>
        <div class="ff-swatches">
          <button
            v-for="b in BACKGROUNDS"
            :key="b.key"
            class="ff-swatch"
            :class="{ 'is-on': ui.bg === b.key }"
            @click="set('bg', b.key)"
          >
            <span class="ff-swatch-dot ff-swatch-bg" :style="{ background: b.swatch }"></span>{{ $t('common.menu.' + b.i18n) }}
          </button>
          <label class="ff-swatch ff-swatch-custom" :class="{ 'is-on': ui.bg === 'custom' }" :title="$t('common.menu.customTitle')">
            <span class="ff-swatch-dot ff-swatch-picker ff-swatch-bg" :style="{ background: ui.bgCustom }">
              <input type="color" :value="ui.bgCustom" @input="setBgCustom($event.target.value)" @click="set('bg', 'custom')">
            </span>{{ $t('common.menu.custom') }}
          </label>
        </div>
      </div>
      <div class="ff-menu-sec">
        <div class="ff-menu-label">{{ $t('common.menu.surface') }}</div>
        <div class="ff-seg">
          <button
            v-for="x in SURFACES"
            :key="x.key"
            :class="{ 'is-on': ui.surface === x.key }"
            @click="set('surface', x.key)"
          >{{ $t('common.menu.' + x.i18n) }}</button>
        </div>
      </div>
      <div class="ff-menu-note">
        {{ $t('common.menu.note') }}
      </div>
    </div>
  </div>
</template>

<script>
import { THEMES, FONT_SIZES, ORDER_HIST_VARIANTS, LANGUAGES, BACKGROUNDS, SURFACES, uiState, saveUiPrefs } from '@/helpers/uiPrefs.js'

export default {
  name: 'UserMenu',

  data () {
    return {
      THEMES,
      FONT_SIZES,
      ORDER_HIST_VARIANTS,
      LANGUAGES,
      BACKGROUNDS,
      SURFACES,
      ui: uiState,
      open: false,
    }
  },

  computed: {
    user () {
      return this.$store.state.user
    },
  },

  mounted () {
    document.addEventListener('click', this.closeOutside)
  },

  beforeUnmount () {
    document.removeEventListener('click', this.closeOutside)
  },

  methods: {
    set (key, value) {
      saveUiPrefs({ ...this.ui, [key]: value })
    },

    setBgCustom (hex) {
      saveUiPrefs({ ...this.ui, bg: 'custom', bgCustom: hex })
    },

    setCustom (hex) {
      saveUiPrefs({ ...this.ui, theme: 'custom', custom: hex })
    },

    closeOutside (event) {
      const root = this.$refs.root
      if (this.open && root && !root.contains(event.target)) this.open = false
    },
  },
}
</script>
